import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { URL_KKN_JOENSUU } from "../../../url/index";

class AppointmentHome extends Component {
  render() {
    const { t } = this.props;
    
    const iframeContainerStyle = {
      position: "relative",
      width: "100%",
      height: "auto",
      overflow: "visible",
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
    };
    
    const iframeStyle = {
      position: "relative",
      width: "100%",
      height: "100%",
      minHeight: "900px",
      border: "none",
      borderRadius: "10px",
      display: "block"
    };
    
    return (
      <section className="appointment py-5" id="appointment" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container py-4">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">
                {t("nav.appointment")}
              </h2>
              <h3 className="section-subheading text-muted mb-5">
                {t("appointmentH.subtitle")}
              </h3>
            </div>
          </div>
          <div className="appointment-content">
            <div style={iframeContainerStyle}>
              <iframe
                title="appointment-booking"
                src={URL_KKN_JOENSUU}
                frameBorder="0"
                style={iframeStyle}
                scrolling="no"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("global")(AppointmentHome);
